import MoreOptions from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { pdf } from "@react-pdf/renderer";
import React,{ useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SpecialAnalysis from "../../api/SpecialAnalysis/SpecialAnalysis";
import ModalSimpleButton from "../../components/Modal/ModalSimpleButton";
import {
  StyledTableBody,
  StyledTableCell,
  StyledTableCellLink,
  StyledTableRow,
  UXDataTableWithoutBody,
} from "../../components/UXDataTable";
import { convertDateFormat,formatMidasNumber } from "../../global";
import Summary from "./PrintableComponents/Summary";
import User from "../../api/Admin/User";
import PrintLabel from "../../api/LIMS/PrintLabel";
import PrintInformation from "../../components/PrintInformation";
import AssignTechnicianModal from "./AssignTechnicianModal";
import { Divider } from "@mui/material";
import { useAuth } from "../../context/AuthContext";
import { Roles } from "../../constants/roles";

const MySpecialAnalysisCols = [
  "ID",
  "Comments",
  "Description",
  "MIDAS #",
  "Priority",
  "Requester",
  "Assigned To",
  "Requested Date",
  "Requested Completion",
  "Last Acceptable Date",
  "Business Unit",
  "Status",
  "Work Request ID",
];

const TableAllRequests = ({
  filters,
  filteredAllRequests,
  userEmail,
  isDataLoading,
  isProcessing,
  billingList,
  reloadSpecialAnalysis,
  copySpecialAnalysis,
}) => {
  const [assignTechnicianModal, setAssignTechnicianModal] = useState(false);
  const [printLabelInfo, setPrintLabelInfo] = useState(null);
  const [printInfoOpen, setPrintInfoOpen] = useState(false);
  const [clickedMenuId, setClickedMenuId] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [moreOptionsSelected, setMoreOptionsSelected] = useState(null);
  const [modalMessagesOpen, setModalMessagesOpen] = useState(false);
  const [modalMessagesText, setModalMessagesText] = useState("");
  const [modalMessagesTitle, setModalMessagesTitle] = useState("");
  const [modalMessagesButtonText, setModalMessagesButtonText] = useState("Ok");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [pageData, setPageData] = useState([]);

  useEffect(() => {
    setPageData(filteredAllRequests.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage));
  }, [page, rowsPerPage, filteredAllRequests]);

  useEffect(() => {
    setPage(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  function closeModalMessages() {
    setModalMessagesOpen(false);
    setModalMessagesText("");
    setModalMessagesButtonText("");
    setModalMessagesTitle("");
  }
  const openModalMessage = (title, message, btnText) => {
    setModalMessagesOpen(true);
    setModalMessagesText(message);
    setModalMessagesButtonText(btnText);
    setModalMessagesTitle(title);
  };

  function handleOpenMoreOptions(e, specialAnalysis) {
    setMoreOptionsSelected(specialAnalysis);

    setAnchorEl(e.currentTarget);
  }

  function handleCloseMoreOptions() {
    setMoreOptionsSelected(null);

    setAnchorEl(null);
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const { hasAnyRole } = useAuth();
  const canAssignRequest = hasAnyRole([Roles.SpecialAnalysisWorker, Roles.Developer]);

  const assignTechnician = (assignTechnicianEmail) => {
    SpecialAnalysis.updateAssignTo(clickedMenuId, assignTechnicianEmail)
      .then((res) => {
        if (res?.message !== "Success") {
          openModalMessage(
            "Fail",
            `There was an error updating technician. ${res?.message ? res?.message : ""}`,
            "Ok",
          );
        } else {
          reloadSpecialAnalysis(clickedMenuId);
          openModalMessage("Success", "Technician successfully updated", "Close");
        }
      })
      .catch((err) => {
        openModalMessage("Error", "There was an error updating technician", "Close");
      });
  };
  const currentRequest = pageData?.find((x) => x.id === clickedMenuId) ?? null;

  async function getSummary() {
    if (moreOptionsSelected && moreOptionsSelected.id) {
      let businessPhones = "";

      const userPreferences = await User.searchByEmailAddress(userEmail);

      if (
        userPreferences &&
        userPreferences.businessPhones &&
        userPreferences.businessPhones.length > 0
      ) {
        businessPhones = userPreferences.businessPhones.join(", ");
      }

      SpecialAnalysis.getById(moreOptionsSelected.id).then((response) => {
        if (response) {
          const asPdf = pdf([]);
          asPdf.updateContainer(
            <Summary
              specialAnalysis={response}
              businessPhones={businessPhones}
              billingList={billingList}></Summary>,
          );

          asPdf.toBlob().then((blob) => {
            var url = window.URL.createObjectURL(blob, { oneTimeOnly: true });
            const link = document.createElement("a");
            link.href = url;
            link.target = "_blank";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          });
        }
      });
    }
  }

  function openPrintInfo(sample) {
    let arrayPrintInfo = [];
    sample.forEach((sample) => {
      let newPrintInfo = new PrintLabel({
        sampleName: sample.sampleName,
        containerNumbers: [sample.existingContainer.containerNumber],
        includeAdditionalSampleInformation: false,
        chemIDOnly: false,
        printLabelSizeType: null,
        isBlindCoded: false,
        blindDescription: null,
        blindSampleName: null,
        isShelfLabel: false,
        shelfLabelText: null,
        includeShelfBarcode: false,
      });

      arrayPrintInfo.push(newPrintInfo);
    });

    setPrintLabelInfo(arrayPrintInfo);
    setPrintInfoOpen(true);
  }

  const reprintLabel = (id) => {
    SpecialAnalysis.getById(id).then((result) => {
      if (!result.specialAnalysisSamples.length) {
        openModalMessage(
          "No samples to print",
          "The selected request has no samples to be printed",
          "Close",
        );
        return;
      }

      openPrintInfo(result.specialAnalysisSamples);
    });
  };
  function closePrintInformation() {
    setPrintInfoOpen(false);
  }

  return (
    <div>
      <UXDataTableWithoutBody
        tableWidth="100%"
        cols={MySpecialAnalysisCols.filter(
          (f) => (!isProcessing && f !== "Business Unit") || isProcessing,
        )}
        blankFirstHeader={true}
        tableId="allStudies"
        rowLength={filteredAllRequests?.length}
        enablePaging={true}
        rowsPerPage={rowsPerPage}
        page={page}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        noDataFoundMessage="No Special Analysis Found"
        isDataLoading={isDataLoading}>
        <StyledTableBody key={"allRequestTablebody"}>
          {pageData.map((specialAnalysis, index) => {
            return (
              <StyledTableRow key={`table-row-${index}`}>
                <StyledTableCell style={{ width: "10px" }}>
                  <MoreOptions
                    onClick={(e) => {
                      setClickedMenuId(specialAnalysis.id);
                      handleOpenMoreOptions(e, specialAnalysis);
                    }}
                    color="black"
                  />
                </StyledTableCell>
                <StyledTableCellLink
                  scope="row"
                  component={Link}
                  to={{
                    pathname: `/viewSpecialAnalysis/${specialAnalysis.id}`,
                    state: { tab: isProcessing ? "process" : "submit" },
                  }}>
                  {specialAnalysis.id}
                </StyledTableCellLink>
                <StyledTableCell align="right">{
                specialAnalysis.comments
                          ?.split("|")
                          ?.filter(
                            (val) =>
                              !val?.includes(":  Old value: '") &&
                              val?.length > 0 &&
                              val?.split("):")[1]?.length > 0,
                          )
                          ?.slice(-2)
                          ?.map((val, index, arr) => (
                            <React.Fragment key={index}>
                              <div>{val}</div>
                              { index < arr.length -1 && (
                                <Divider sx={{ width: "100%", margin: "6px 0"}}/>
                                )
                              }
                            </React.Fragment>
                            ))}</StyledTableCell>
                <StyledTableCell align="right">{specialAnalysis.description}</StyledTableCell>
                <StyledTableCell align="center">{specialAnalysis.specialAnalysisSamples.map(p => formatMidasNumber(p.sampleName)).join(", ")}</StyledTableCell>
                <StyledTableCell align="right">{specialAnalysis.priorityName}</StyledTableCell>
                <StyledTableCell align="right">{specialAnalysis.requestedByEmail}</StyledTableCell>
                <StyledTableCell align="right">{specialAnalysis.assignedToEmail}</StyledTableCell>
                <StyledTableCell align="right">
                  {convertDateFormat(specialAnalysis.createdDate, false)}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {convertDateFormat(specialAnalysis.requestedCompletionDate, false)}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {convertDateFormat(specialAnalysis.lastAcceptableCompletionDate, false)}
                </StyledTableCell>
                {isProcessing && (
                  <StyledTableCell align="right">
                    {specialAnalysis.businessUnitName}
                  </StyledTableCell>
                )}
                <StyledTableCell align="right">{specialAnalysis.statusName}</StyledTableCell>
                <StyledTableCellLink
                  scope="row"
                  component={Link}
                  to={{
                    pathname:
                      specialAnalysis.parentSpecialAnalysisID !== undefined
                        ? `/viewSpecialAnalysis/${specialAnalysis.parentSpecialAnalysisID}`
                        : `/workrequests`,
                    state: { tab: isProcessing ? "process" : "submit" },
                  }}>
                  {specialAnalysis.parentSpecialAnalysisID}
                </StyledTableCellLink>
              </StyledTableRow>
            );
          })}
        </StyledTableBody>
      </UXDataTableWithoutBody>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={anchorEl && moreOptionsSelected ? true : false}
        onClose={() => handleCloseMoreOptions()}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}>
        {isProcessing && (
          <>
            <MenuItem
              onClick={() => {
                getSummary();
                handleCloseMoreOptions();
              }}>
              Print
            </MenuItem>
            <MenuItem
              onClick={() => {
                reprintLabel(currentRequest.id);
                handleCloseMoreOptions();
              }}
              disabled={false}>
              Reprint Special Analysis Label
            </MenuItem>
            <MenuItem
              onClick={() => {
                setAssignTechnicianModal(true);
                handleCloseMoreOptions();
              }}
              disabled={!canAssignRequest}>
              Assign
            </MenuItem>
          </>
        )}
        <MenuItem
          onClick={() => {
            copySpecialAnalysis(currentRequest.id);
            handleCloseMoreOptions();
          }}>
          Copy Special Analysis
        </MenuItem>
      </Menu>

      <ModalSimpleButton
        title={modalMessagesTitle}
        buttonText={modalMessagesButtonText}
        buttonAction={closeModalMessages}
        open={modalMessagesOpen}
        setOpen={setModalMessagesOpen}>
        <div dangerouslySetInnerHTML={{ __html: modalMessagesText }} />
      </ModalSimpleButton>
      {clickedMenuId > 0 && (
        <AssignTechnicianModal
          specialAnalysisId={clickedMenuId}
          assignTechnician={assignTechnician}
          assignTechnicianModal={assignTechnicianModal}
          setAssignTechnicianModal={setAssignTechnicianModal}
        />
      )}
      <PrintInformation
        open={printInfoOpen}
        setOpen={setPrintInfoOpen}
        button2Action={closePrintInformation}
        button2Text="Close"
        printLabelInfo={printLabelInfo}
        isShelfLabel={false}
      />
    </div>
  );
};

export default TableAllRequests;
